/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum NotificationDeliveryCadenceEnum {
    REAL_TIME = 'REAL_TIME',
    DAILY_DIGEST = 'DAILY_DIGEST',
}
